(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('article-overview')) {
    customElements.define(
      'article-overview',
      class ArticleOverview extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.grid = this.querySelector('[data-article-grid]');
          this.tabs = this.querySelector('[data-type-tabs]');
          this.pagination = this.querySelector('[data-pagination]');
          this.emptyState = this.querySelector('[data-filter-empty]');
          this.status = this.querySelector('[data-results-status]');
          this.sort = this.querySelector('[data-article-sort]');
          this.currentPage = 1;
          this.selectedType = '';
          this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 9);

          if (!this.grid) return;
          this.refreshCards();
          this.buildTypeTabs();
          this.bindEvents();
          this.applyResults();
          this.loadRemainingArticles();
        }

        bindEvents() {
          this.tabs?.addEventListener('click', (event) => {
            const selectedTab = event.target.closest('[data-type-tab]');
            if (!selectedTab || !this.tabs.contains(selectedTab)) return;
            this.selectType(selectedTab.dataset.value || '', selectedTab);
          });

          this.sort?.addEventListener('change', () => {
            this.currentPage = 1;
            this.applyResults();
          });
        }

        refreshCards() {
          this.cards = Array.from(this.querySelectorAll('[data-article-card]'));
          this.cards.forEach((card, index) => {
            card.dataset.originalIndex = index;
          });
        }

        normalize(value) {
          return String(value || '').trim().toLocaleLowerCase();
        }

        cardTypes(card) {
          try {
            const values = JSON.parse(card.dataset.blogTypes || '[]');
            if (!Array.isArray(values)) return values ? [String(values).trim()] : [];
            return values.map((value) => String(value || '').trim()).filter(Boolean);
          } catch {
            const fallback = String(card.dataset.blogTypes || '').trim();
            return fallback ? [fallback] : [];
          }
        }

        typeCounts() {
          const counts = new Map();
          this.cards.forEach((card) => {
            const cardTypeKeys = new Set();
            this.cardTypes(card).forEach((label) => {
              const key = this.normalize(label);
              if (!key || cardTypeKeys.has(key)) return;
              cardTypeKeys.add(key);
              const existing = counts.get(key);
              if (existing) {
                existing.count += 1;
              } else {
                counts.set(key, { key, label, count: 1 });
              }
            });
          });

          return Array.from(counts.values()).sort((a, b) => {
            if (b.count !== a.count) return b.count - a.count;
            return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
          });
        }

        buildTypeTabs() {
          if (!this.tabs) return;
          const availableTypes = this.typeCounts();
          if (this.selectedType && !availableTypes.some((type) => type.key === this.selectedType)) {
            this.selectedType = '';
          }

          const fragment = document.createDocumentFragment();
          fragment.append(this.createTypeTab(this.dataset.allLabel || 'All articles', '', this.selectedType === ''));
          availableTypes.forEach((type) => {
            fragment.append(
              this.createTypeTab(`${type.label} (${type.count})`, type.label, type.key === this.selectedType)
            );
          });
          this.tabs.replaceChildren(fragment);
        }

        createTypeTab(label, value, active) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'article-overview__type-tab';
          button.dataset.typeTab = '';
          button.dataset.value = value;
          button.textContent = label;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
          return button;
        }

        selectType(value, selectedTab) {
          this.selectedType = this.normalize(value);
          this.tabs?.querySelectorAll('[data-type-tab]').forEach((tab) => {
            const isActive = tab === selectedTab;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', String(isActive));
          });
          selectedTab?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          this.currentPage = 1;
          this.applyResults();
        }

        cardMatches(card) {
          return (
            this.selectedType === '' ||
            this.cardTypes(card).some((type) => this.normalize(type) === this.selectedType)
          );
        }

        sortCards(cards) {
          const sortMode = this.sort?.value || 'newest';
          return cards.sort((a, b) => {
            if (sortMode === 'title') {
              return String(a.dataset.title || '').localeCompare(String(b.dataset.title || ''), undefined, {
                sensitivity: 'base'
              });
            }

            const aDate = Number(a.dataset.published) || 0;
            const bDate = Number(b.dataset.published) || 0;
            if (aDate === bDate) {
              return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
            }
            return sortMode === 'oldest' ? aDate - bDate : bDate - aDate;
          });
        }

        applyResults(scrollToGrid = false) {
          if (!this.grid || !this.cards) return;
          const matching = this.sortCards(this.cards.filter((card) => this.cardMatches(card)));
          const matchingSet = new Set(matching);
          matching.forEach((card) => this.grid.append(card));
          this.cards.filter((card) => !matchingSet.has(card)).forEach((card) => this.grid.append(card));

          const totalPages = Math.max(1, Math.ceil(matching.length / this.pageSize));
          this.currentPage = Math.min(this.currentPage, totalPages);
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;

          this.cards.forEach((card) => {
            card.hidden = true;
            card.removeAttribute('data-page-position');
            card.dataset.cardLayout = 'featured';
          });

          matching.slice(start, end).forEach((card, index) => {
            const position = index + 1;
            card.hidden = false;
            card.dataset.pagePosition = position;
            card.dataset.cardLayout = 'featured';
          });

          if (this.emptyState) this.emptyState.hidden = matching.length !== 0;
          if (this.status) {
            const noun = matching.length === 1 ? this.dataset.articleSingular : this.dataset.articlePlural;
            this.status.textContent = `${matching.length} ${noun}`;
          }
          this.updateTypeTabs();
          this.renderPagination(matching.length);

          if (scrollToGrid) {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.grid.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          }
        }

        updateTypeTabs() {
          this.tabs?.querySelectorAll('[data-type-tab]').forEach((tab) => {
            const isActive = this.normalize(tab.dataset.value) === this.selectedType;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', String(isActive));
          });
        }

        pageItems(totalPages) {
          if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
          const values = new Set([1, totalPages, this.currentPage - 1, this.currentPage, this.currentPage + 1]);
          const pages = Array.from(values)
            .filter((page) => page >= 1 && page <= totalPages)
            .sort((a, b) => a - b);
          const items = [];
          pages.forEach((page, index) => {
            if (index > 0 && page - pages[index - 1] > 1) items.push('gap');
            items.push(page);
          });
          return items;
        }

        renderPagination(resultCount) {
          if (!this.pagination) return;
          const totalPages = Math.ceil(resultCount / this.pageSize);
          this.pagination.replaceChildren();
          this.pagination.hidden = totalPages <= 1;
          if (totalPages <= 1) return;

          this.pagination.append(
            this.paginationButton('previous', this.currentPage - 1, this.currentPage === 1)
          );
          this.pageItems(totalPages).forEach((item) => {
            if (item === 'gap') {
              const gap = document.createElement('span');
              gap.className = 'article-overview__pagination-gap';
              gap.textContent = '…';
              gap.setAttribute('aria-hidden', 'true');
              this.pagination.append(gap);
              return;
            }
            this.pagination.append(this.paginationButton(String(item), item, false, item === this.currentPage));
          });
          this.pagination.append(
            this.paginationButton('next', this.currentPage + 1, this.currentPage === totalPages)
          );
        }

        paginationButton(label, page, disabled, current = false) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'article-overview__pagination-button';
          button.disabled = disabled;

          if (label === 'previous' || label === 'next') {
            button.classList.add('is-arrow');
            button.setAttribute(
              'aria-label',
              label === 'previous' ? this.dataset.previousLabel : this.dataset.nextLabel
            );
            button.innerHTML =
              label === 'previous'
                ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12 5-5 5 5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>'
                : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m8 5 5 5-5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>';
          } else {
            button.textContent = label;
            button.setAttribute('aria-label', `${this.dataset.pageLabel || 'Page'} ${label}`);
          }

          if (current) {
            button.classList.add('is-current');
            button.setAttribute('aria-current', 'page');
          }
          button.addEventListener('click', () => {
            this.currentPage = page;
            this.applyResults(true);
          });
          return button;
        }

        async loadRemainingArticles() {
          const source = this.querySelector('[data-source-pages]');
          const totalPages = Number(source?.dataset.sourcePages) || 1;
          if (totalPages <= 1) return;
          this.setAttribute('aria-busy', 'true');
          if (this.status) this.status.textContent = this.dataset.loadingLabel || 'Loading all articles';

          const pageParam = source.dataset.pageParam || 'page';
          const batches = [];
          for (let page = 2; page <= totalPages; page += 4) {
            const pageNumbers = [];
            for (let offset = 0; offset < 4 && page + offset <= totalPages; offset += 1) {
              pageNumbers.push(page + offset);
            }
            batches.push(pageNumbers);
          }
          const knownIds = new Set(this.cards.map((card) => card.dataset.articleId));

          for (const batch of batches) {
            const responses = await Promise.all(
              batch.map(async (page) => {
                try {
                  const url = new URL(window.location.href);
                  url.searchParams.set('section_id', this.dataset.sectionId);
                  url.searchParams.set(pageParam, String(page));
                  const response = await fetch(url.toString(), {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                  });
                  if (!response.ok) return [];
                  const markup = await response.text();
                  const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
                  return Array.from(documentFragment.querySelectorAll('[data-article-card]'));
                } catch {
                  return [];
                }
              })
            );

            responses.flat().forEach((card) => {
              if (knownIds.has(card.dataset.articleId)) return;
              knownIds.add(card.dataset.articleId);
              this.grid.append(document.importNode(card, true));
            });
          }

          this.removeAttribute('aria-busy');
          this.refreshCards();
          this.buildTypeTabs();
          this.applyResults();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buying-usp-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buying-usp-carousel')) {
    customElements.define('buying-usp-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mobileLayout !== 'carousel') return;
        this.list = this.querySelector('.buying-usp-footer__list');
        if (!this.list) return;
        this.items = [...this.list.children];
        this.pauseButton = this.querySelector('[data-usp-pause]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reducedMotion.matches;
        this.visible = false;
        this.hovered = false;
        this.index = 0;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.setAttribute('data-ready', '');
        this.list.tabIndex = this.mobile.matches ? 0 : -1;
        this.querySelector('[data-usp-previous]')?.addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-usp-next]')?.addEventListener('click', () => this.move(1), options);
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.update();
        }, options);
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list || !this.mobile.matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.list.addEventListener('scroll', () => {
          if (this.list.clientWidth) this.index = Math.round(this.list.scrollLeft / this.list.clientWidth);
        }, options);
        this.list.addEventListener('pointerdown', () => {
          this.paused = true;
          this.update();
        }, options);
        this.list.addEventListener('mouseenter', () => { this.hovered = true; this.update(); }, options);
        this.list.addEventListener('mouseleave', () => { this.hovered = false; this.update(); }, options);
        this.addEventListener('focusin', event => {
          if (event.target === this.pauseButton) {
            clearInterval(this.timer);
            return;
          }
          this.paused = true;
          this.update();
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.mobile.addEventListener('change', () => {
          this.list.tabIndex = this.mobile.matches ? 0 : -1;
          this.list.scrollTo({ left: 0, behavior: 'instant' });
          this.index = 0;
          this.update();
        }, options);
        this.reducedMotion.addEventListener('change', () => {
          if (this.reducedMotion.matches) this.paused = true;
          this.update();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item === event.target || item.contains(event.target));
          if (index < 0 || !this.mobile.matches) return;
          this.paused = true;
          this.show(index);
          this.update();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
        this.update();
      }

      show(index) {
        this.index = (index + this.items.length) % this.items.length;
        this.list.scrollTo({
          left: this.index * this.list.clientWidth,
          behavior: this.reducedMotion.matches ? 'instant' : 'smooth'
        });
      }

      move(direction) {
        this.show(this.index + direction);
        this.update();
      }

      update() {
        clearInterval(this.timer);
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
          this.pauseButton.toggleAttribute('data-paused', this.paused);
        }
        if (this.mobile.matches && this.items.length > 1 && this.visible && !this.paused && !this.hovered && !document.hidden) {
          this.timer = setInterval(() => this.show(this.index + 1), 3000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-revogan"] && !Shopify.designMode) return;
  try {
    
  class RevoganCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
      document.addEventListener('shopify:cart:lines-update', this.handleCartUpdate, { signal: this.abortController.signal });
      this.load();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.requestController?.abort();
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-direction]');
      if (!button || !this.contains(button)) return;
      const track = this.querySelector('[data-recommendations-track]');
      if (!track) return;
      const direction = button.dataset.direction === 'previous' ? -1 : 1;
      track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    };

    handleCartUpdate = (event) => {
      event.promise?.then(() => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.isConnected) this.load();
        }));
      }).catch(() => {});
    };

    async load(force = false) {
      const productId = this.dataset.productId;
      const sectionId = this.dataset.sectionId;
      if (!productId || !sectionId || (!force && this.dataset.loadedFor === productId)) return;

      this.requestController?.abort();
      this.requestController = new AbortController();

      try {
        const separator = this.dataset.url.includes('?') ? '&' : '?';
        const response = await fetch(`${this.dataset.url}${separator}product_id=${productId}&section_id=${sectionId}`, {
          signal: this.requestController.signal,
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error(`Aanbevelingen konden niet worden geladen (${response.status})`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = documentFragment.querySelector(`#RevoganRecommendationsContent-${CSS.escape(sectionId)}`);
        const target = this.querySelector(`#RevoganRecommendationsContent-${CSS.escape(sectionId)}`);
        if (!source || !target) {
          this.dataset.loadedFor = productId;
          return;
        }

        if (source.querySelector('[data-recommendations-track]')) {
          target.replaceChildren(...Array.from(source.childNodes).map((node) => document.importNode(node, true)));
        }
        this.dataset.loadedFor = productId;
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('[revogan-cart-drawer] Productaanbevelingen:', error);
          this.dataset.loadedFor = productId;
        }
      }
    }
  }

  if (!customElements.get('revogan-cart-recommendations')) {
    customElements.define('revogan-cart-recommendations', RevoganCartRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-revogan"] && !Shopify.designMode) return;
  try {
    
  class CollectionRevoganElement extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('[data-form-filter]');
      this.nativeSelect = this.querySelector('[data-native-filter]');
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.emptyState = this.querySelector('[data-filter-empty]');
      this.resultCount = this.querySelector('[data-result-count]');
      this.paginationLinks = Array.from(this.querySelectorAll('[data-pagination] a'));

      if (this.nativeSelect) {
        const serverCount = Number(this.resultCount?.dataset.serverCount || this.cards.length);
        this.updateResultCount(serverCount);
        this.nativeSelect.addEventListener('change', () => this.nativeSelect.form.submit());
        return;
      }

      if (!this.select) return;

      const requestedValue = new URL(window.location.href).searchParams.get('supplement_form');
      if (requestedValue && Array.from(this.select.options).some((option) => option.value === requestedValue)) {
        this.select.value = requestedValue;
      }

      this.select.addEventListener('change', () => this.applyFilter(true));
      this.applyFilter(false);
    }

    applyFilter(updateUrl) {
      const value = this.select.value;
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const matches = value === '' || card.dataset.formValues.includes(`|${value}|`);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (this.emptyState) this.emptyState.hidden = visibleCount > 0;

      if (this.resultCount) {
        this.updateResultCount(visibleCount);
      }

      const currentUrl = new URL(window.location.href);
      if (value) currentUrl.searchParams.set('supplement_form', value);
      else currentUrl.searchParams.delete('supplement_form');

      if (updateUrl) window.history.replaceState({}, '', currentUrl);

      this.paginationLinks.forEach((link) => {
        const linkUrl = new URL(link.href);
        if (value) linkUrl.searchParams.set('supplement_form', value);
        else linkUrl.searchParams.delete('supplement_form');
        link.href = linkUrl.toString();
      });
    }

    updateResultCount(count) {
      if (!this.resultCount) return;
      this.resultCount.textContent = `${count} ${this.dataset.resultLabel}`;
    }
  }

  if (!customElements.get('collection-revogan')) {
    customElements.define('collection-revogan', CollectionRevoganElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expert-videos')) {
    customElements.define(
      'expert-videos',
      class ExpertVideos extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-expert-track]');
          this.viewport = this.querySelector('[data-expert-viewport]');
          this.previousButton = this.querySelector('[data-expert-previous]');
          this.nextButton = this.querySelector('[data-expert-next]');
          this.progress = this.querySelector('[data-expert-progress]');
          this.emptyState = this.querySelector('[data-expert-empty]');
          this.status = this.querySelector('[data-expert-status]');
          this.dialog = this.querySelector('[data-expert-dialog]');
          this.dialogContent = this.querySelector('[data-expert-dialog-content]');
          this.dialogClose = this.querySelector('[data-expert-dialog-close]');
          this.slides = Array.from(this.querySelectorAll('[data-expert-slide]'));
          this.interval = Number(this.dataset.interval) || 15000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
          this.autoplayVideos = this.dataset.autoplayVideos === 'true' && !this.reducedMotion;
          this.pauseOnHover = this.dataset.pauseOnHover === 'true';
          this.current = null;
          this.locked = false;
          this.autoplayTimer = null;
          this.transitionTimer = null;

          if (!this.track || !this.viewport || this.slides.length === 0) return;

          this.onResize = () => this.translateToCurrent(false);
          this.onVisibilityChange = () => {
            if (document.hidden) {
              this.pauseAutoplay();
              this.pauseVideos();
            } else {
              this.playCurrentVideo();
              this.scheduleAutoplay();
            }
          };

          this.bindEvents();
          this.applyFilter('');
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          document.addEventListener('visibilitychange', this.onVisibilityChange);
        }

        disconnectedCallback() {
          clearTimeout(this.autoplayTimer);
          clearTimeout(this.transitionTimer);
          this.resizeObserver?.disconnect();
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }

        bindEvents() {
          this.querySelectorAll('[data-expert-filter]').forEach((button) => {
            button.addEventListener('click', () => this.applyFilter(button.dataset.category || ''));
          });

          this.previousButton?.addEventListener('click', () => this.go(-1));
          this.nextButton?.addEventListener('click', () => this.go(1));
          this.querySelectorAll('[data-expert-play]').forEach((button) => {
            const video = button.closest('.expert-videos__media')?.querySelector('video');
            if (!video) return;
            button.addEventListener('click', () => this.openDialog(video));
          });
          this.dialogClose?.addEventListener('click', () => this.dialog?.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog?.addEventListener('close', () => this.closeDialog());

          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', () => this.pauseAutoplay());
            this.addEventListener('mouseleave', () => this.scheduleAutoplay());
            this.addEventListener('focusin', () => this.pauseAutoplay());
            this.addEventListener('focusout', (event) => {
              if (!this.contains(event.relatedTarget)) this.scheduleAutoplay();
            });
          }

          this.addEventListener('shopify:block:select', (event) => {
            const selectedSlide = event.target.closest('[data-expert-slide]');
            if (!selectedSlide || !this.slides.includes(selectedSlide)) return;
            this.showSlide(selectedSlide);
            this.pauseAutoplay();
          });
        }

        visibleSlides() {
          return Array.from(this.track.children).filter(
            (slide) => slide.matches('[data-expert-slide]') && !slide.hidden
          );
        }

        openDialog(sourceVideo) {
          if (!this.dialog || !this.dialogContent) return;
          this.pauseAutoplay();
          this.pauseVideos();

          const dialogVideo = sourceVideo.cloneNode(true);
          dialogVideo.className = 'expert-videos__dialog-video';
          dialogVideo.controls = true;
          dialogVideo.muted = false;
          dialogVideo.loop = false;
          dialogVideo.autoplay = true;
          this.dialogContent.replaceChildren(dialogVideo);
          this.dialog.showModal();
          dialogVideo.play().catch(() => undefined);
        }

        closeDialog() {
          const dialogVideo = this.dialogContent?.querySelector('video');
          dialogVideo?.pause();
          this.dialogContent?.replaceChildren();
          this.playCurrentVideo();
          this.scheduleAutoplay();
        }

        applyFilter(category) {
          clearTimeout(this.transitionTimer);
          this.locked = false;
          const matching = this.slides.filter((slide) => !category || slide.dataset.category === category);
          const excluded = this.slides.filter((slide) => !matching.includes(slide));

          this.slides.forEach((slide) => {
            slide.hidden = !matching.includes(slide);
          });

          let ordered = [...matching];
          if (ordered.length > 2) ordered = [ordered[ordered.length - 1], ...ordered.slice(0, -1)];
          this.track.replaceChildren(...ordered, ...excluded);
          this.current = matching[0] || null;
          this.setCurrent(this.current);

          this.querySelectorAll('[data-expert-filter]').forEach((button) => {
            const active = (button.dataset.category || '') === category;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          const hasMultiple = matching.length > 1;
          if (this.previousButton) this.previousButton.hidden = !hasMultiple;
          if (this.nextButton) this.nextButton.hidden = !hasMultiple;
          if (this.progress) this.progress.hidden = !hasMultiple || !this.autoplayEnabled;
          if (this.emptyState) this.emptyState.hidden = matching.length !== 0;

          if (this.status) {
            const noun = matching.length === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
            this.status.textContent = `${matching.length} ${noun}`;
          }

          requestAnimationFrame(() => this.translateToCurrent(false));
          this.scheduleAutoplay();
        }

        showSlide(slide) {
          if (slide.hidden) {
            const filter = this.querySelector(`[data-expert-filter][data-category="${CSS.escape(slide.dataset.category)}"]`);
            this.applyFilter(filter?.dataset.category || '');
          }

          const visible = this.visibleSlides();
          if (!visible.includes(slide)) return;
          let ordered = [...visible];
          const index = ordered.indexOf(slide);
          if (ordered.length > 2) {
            while (ordered.indexOf(slide) > 1) ordered.push(ordered.shift());
            while (ordered.indexOf(slide) < 1) ordered.unshift(ordered.pop());
          } else if (index > 0) {
            ordered = [slide, ...ordered.filter((item) => item !== slide)];
          }

          const excluded = this.slides.filter((item) => item.hidden);
          this.track.replaceChildren(...ordered, ...excluded);
          this.setCurrent(slide);
          requestAnimationFrame(() => this.translateToCurrent(false));
        }

        go(direction) {
          const visible = this.visibleSlides();
          if (this.locked || visible.length < 2 || !this.current) return;

          const currentIndex = visible.indexOf(this.current);
          let targetIndex = currentIndex + direction;
          if (targetIndex < 0) targetIndex = visible.length - 1;
          if (targetIndex >= visible.length) targetIndex = 0;

          this.locked = true;
          this.setCurrent(visible[targetIndex]);
          this.translateToCurrent(true);
          this.scheduleAutoplay();

          this.transitionTimer = setTimeout(() => {
            this.normalizeOrder();
            this.locked = false;
          }, this.reducedMotion ? 0 : 700);
        }

        normalizeOrder() {
          let visible = this.visibleSlides();
          if (visible.length > 2 && this.current) {
            while (visible.indexOf(this.current) > 1) visible.push(visible.shift());
            while (visible.indexOf(this.current) < 1) visible.unshift(visible.pop());
            const excluded = this.slides.filter((slide) => slide.hidden);
            this.track.replaceChildren(...visible, ...excluded);
          }
          this.translateToCurrent(false);
        }

        setCurrent(slide) {
          this.current = slide;
          this.slides.forEach((item) => {
            const active = item === slide;
            item.classList.toggle('is-active', active);
            if (active) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
          this.playCurrentVideo();
        }

        translateToCurrent(animated) {
          if (!this.current || !this.viewport) {
            this.track.style.transform = '';
            return;
          }

          if (!animated) this.track.classList.add('is-instant');
          const visible = this.visibleSlides();
          const offset = window.innerWidth >= 990 && visible.length >= 4
            ? visible[0].offsetLeft - 24
            : this.current.offsetLeft + this.current.offsetWidth / 2 - this.viewport.clientWidth / 2;
          this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

          if (!animated) {
            requestAnimationFrame(() => this.track.classList.remove('is-instant'));
          }
        }

        pauseVideos() {
          this.slides.forEach((slide) => {
            slide.querySelector('video')?.pause();
          });
        }

        playCurrentVideo() {
          this.pauseVideos();
          if (!this.autoplayVideos || !this.current || document.hidden || this.dialog?.open) return;
          const video = this.current.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.play().catch(() => undefined);
        }

        pauseAutoplay() {
          clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
          this.progress?.classList.add('is-paused');
        }

        scheduleAutoplay() {
          clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
          this.resetProgress();
          if (!this.autoplayEnabled || document.hidden || this.visibleSlides().length < 2) return;
          this.autoplayTimer = setTimeout(() => this.go(1), this.interval);
        }

        resetProgress() {
          if (!this.progress) return;
          this.progress.classList.remove('is-running', 'is-paused');
          void this.progress.offsetWidth;
          if (this.autoplayEnabled && this.visibleSlides().length > 1) {
            this.progress.classList.add('is-running');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mega-v2"] && !Shopify.designMode) return;
  try {
    
  class RevoganMegaHeader extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      this.triggers = [...this.querySelectorAll('[data-mega-trigger]')];
      this.panels = [...this.querySelectorAll('[data-mega-panel]')];
      this.backdrop = this.querySelector('[data-mega-backdrop]');
      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.mobileDrawer = this.querySelector('[data-mobile-drawer]');
      this.mobileClose = this.querySelector('[data-mobile-close]');
      this.pageScrollContainer = document.querySelector('.page-wrapper');
      this.closeTimer = null;

      this.updateScrollState = () => {
        if (!this.hasAttribute('data-page-overlay')) return;
        const scrollTop = Math.max(window.scrollY, this.pageScrollContainer?.scrollTop ?? 0);
        this.classList.toggle('is-scrolled', scrollTop > 0);
      };
      this.updateScrollState();
      window.addEventListener('scroll', this.updateScrollState, { passive: true, signal: this.signal });
      this.pageScrollContainer?.addEventListener('scroll', this.updateScrollState, {
        passive: true,
        signal: this.signal,
      });

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('pointerenter', () => this.openPanel(trigger), { signal: this.signal });
        trigger.addEventListener('focus', () => this.openPanel(trigger), { signal: this.signal });
        trigger.addEventListener('click', () => this.togglePanel(trigger), { signal: this.signal });
        trigger.addEventListener('keydown', (event) => this.handleTriggerKeydown(event, trigger), {
          signal: this.signal,
        });
      });

      this.querySelectorAll('[data-resource-tab]').forEach((tab) => {
        tab.addEventListener('pointerenter', () => this.activateResourceTab(tab), { signal: this.signal });
        tab.addEventListener('focus', () => this.activateResourceTab(tab), { signal: this.signal });
        tab.addEventListener('click', () => this.activateResourceTab(tab), { signal: this.signal });
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, tab), { signal: this.signal });
      });

      this.addEventListener('pointerleave', () => this.scheduleClose(), { signal: this.signal });
      this.addEventListener('pointerenter', () => this.cancelClose(), { signal: this.signal });
      this.backdrop?.addEventListener('pointerenter', () => {
        if (this.hasAttribute('data-panel-open')) this.scheduleClose();
      }, { signal: this.signal });
      this.querySelector('.revogan-mega-v2__bar')?.addEventListener('pointerenter', () => this.cancelClose(), { signal: this.signal });
      this.panels.forEach((panel) => {
        panel.addEventListener('pointerenter', () => this.cancelClose(), { signal: this.signal });
        panel.addEventListener('pointerleave', () => this.scheduleClose(), { signal: this.signal });
      });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closePanels();
      }, { signal: this.signal });

      this.backdrop?.addEventListener('click', () => {
        this.closePanels();
        this.closeMobileDrawer();
      }, { signal: this.signal });

      this.mobileToggle?.addEventListener('click', () => this.toggleMobileDrawer(), { signal: this.signal });
      this.mobileClose?.addEventListener('click', () => this.closeMobileDrawer(), { signal: this.signal });
      this.mobileDrawer?.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.closeMobileDrawer();
      }, { signal: this.signal });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closePanels();
          this.closeMobileDrawer();
        }
      }, { signal: this.signal });

      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const panel = event.target.closest('[data-mega-panel]');
        if (!panel) return;
        const trigger = this.triggers.find((item) => item.dataset.megaTrigger === panel.dataset.megaPanel);
        if (trigger) this.openPanel(trigger);
      }, { signal: this.signal });

      window.addEventListener('resize', () => {
        if (window.innerWidth < 1280) this.closePanels();
        if (window.innerWidth >= 1280) this.closeMobileDrawer();
      }, { signal: this.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.cancelClose();
    }

    togglePanel(trigger) {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.closePanels();
      } else {
        this.openPanel(trigger);
      }
    }

    openPanel(trigger) {
      if (window.innerWidth < 1280) return;
      this.cancelClose();
      const handle = trigger.dataset.megaTrigger;
      const panel = this.panels.find((item) => item.dataset.megaPanel === handle);
      if (!panel) return;

      this.triggers.forEach((item) => item.setAttribute('aria-expanded', String(item === trigger)));
      this.panels.forEach((item) => {
        const shouldOpen = item === panel;
        item.hidden = !shouldOpen;
        item.classList.toggle('is-open', shouldOpen);
      });

      this.setAttribute('data-panel-open', '');
      if (panel.dataset.panelVariant === 'compact') this.positionCompactPanel(panel, trigger);
      this.showBackdrop();
    }

    positionCompactPanel(panel, trigger) {
      const rootRect = this.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const panelWidth = panel.getBoundingClientRect().width;
      const pageMargin = 24;
      const preferredLeft = triggerRect.left - rootRect.left - 32;
      const maximumLeft = Math.max(pageMargin, rootRect.width - panelWidth - pageMargin);
      const left = Math.min(Math.max(preferredLeft, pageMargin), maximumLeft);
      panel.style.setProperty('--compact-panel-left', `${left}px`);
    }

    scheduleClose() {
      this.cancelClose();
      this.closeTimer = window.setTimeout(() => this.closePanels(), 160);
    }

    cancelClose() {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    closePanels() {
      this.cancelClose();
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.panels.forEach((panel) => {
        panel.classList.remove('is-open');
        panel.hidden = true;
      });
      this.removeAttribute('data-panel-open');
      if (!this.hasAttribute('data-mobile-open')) this.hideBackdrop();
    }

    activateResourceTab(tab) {
      const panel = tab.closest('[data-mega-panel]');
      if (!panel) return;
      const handle = tab.dataset.resourceTab;
      const tabs = [...panel.querySelectorAll('[data-resource-tab]')];
      const views = [...panel.querySelectorAll('[data-resource-view]')];

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });
      views.forEach((view) => {
        view.hidden = view.dataset.resourceView !== handle;
      });
    }

    handleTriggerKeydown(event, trigger) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.openPanel(trigger);
        const panel = this.panels.find((item) => item.dataset.megaPanel === trigger.dataset.megaTrigger);
        panel?.querySelector('a, button')?.focus();
      }
    }

    handleTabKeydown(event, tab) {
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const panel = tab.closest('[data-mega-panel]');
      const tabs = [...panel.querySelectorAll('[data-resource-tab]')];
      const currentIndex = tabs.indexOf(tab);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      tabs[nextIndex].focus();
      this.activateResourceTab(tabs[nextIndex]);
    }

    toggleMobileDrawer() {
      if (this.mobileDrawer?.open) {
        this.closeMobileDrawer();
      } else {
        this.openMobileDrawer();
      }
    }

    openMobileDrawer() {
      if (!this.mobileDrawer || this.mobileDrawer.open) return;
      this.closePanels();
      this.mobileDrawer.show();
      this.setAttribute('data-mobile-open', '');
      this.mobileToggle?.setAttribute('aria-expanded', 'true');
      document.documentElement.setAttribute('scroll-lock', '');
      this.showBackdrop();
      this.mobileClose?.focus();
    }

    closeMobileDrawer() {
      if (!this.mobileDrawer?.open) return;
      this.mobileDrawer.close();
      this.removeAttribute('data-mobile-open');
      this.mobileToggle?.setAttribute('aria-expanded', 'false');
      document.documentElement.removeAttribute('scroll-lock');
      this.hideBackdrop();
    }

    showBackdrop() {
      if (!this.backdrop) return;
      this.backdrop.hidden = false;
      window.requestAnimationFrame(() => this.backdrop.classList.add('is-visible'));
    }

    hideBackdrop() {
      if (!this.backdrop) return;
      this.backdrop.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!this.backdrop.classList.contains('is-visible')) this.backdrop.hidden = true;
      }, 220);
    }
  }

  if (!customElements.get('revogan-mega-header')) {
    customElements.define('revogan-mega-header', RevoganMegaHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-main"] && !Shopify.designMode) return;
  try {
    
  const updateHeroBannerViewportHeight = () => {
    const heroes = document.querySelectorAll(
      '.content-for-layout > .hero-banner-main-section:first-child .hero-banner-main'
    );

    heroes.forEach((hero) => {
      const section = hero.closest('.hero-banner-main-section');
      if (!(section instanceof HTMLElement)) return;

      const sectionTop = Math.max(section.getBoundingClientRect().top + window.scrollY, 0);
      hero.style.setProperty('--hero-banner-main-viewport-height', `calc(100svh - ${sectionTop}px)`);
    });
  };

  let heroBannerResizeFrame;
  const queueHeroBannerViewportHeightUpdate = () => {
    window.cancelAnimationFrame(heroBannerResizeFrame);
    heroBannerResizeFrame = window.requestAnimationFrame(updateHeroBannerViewportHeight);
  };

  updateHeroBannerViewportHeight();
  window.addEventListener('resize', queueHeroBannerViewportHeightUpdate, { passive: true });
  document.addEventListener('shopify:section:load', queueHeroBannerViewportHeightUpdate);

  if (document.fonts?.ready) {
    document.fonts.ready.then(queueHeroBannerViewportHeightUpdate);
  }

  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar instanceof HTMLElement && 'ResizeObserver' in window) {
    new ResizeObserver(queueHeroBannerViewportHeightUpdate).observe(announcementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-related-videos')) {
    class ProductRelatedVideos extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-video-dialog]');
        if (!this.dialog || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.dialogTitle = this.querySelector('[data-dialog-title]');
        this.panels = Array.from(this.querySelectorAll('[data-video-panel]'));
        this.previousBodyOverflow = '';
        this.track = this.querySelector('[data-related-track]');
        this.previousArrow = this.querySelector('[data-related-previous]');
        this.nextArrow = this.querySelector('[data-related-next]');
        const moveTrack = (direction) => {
          const card = this.track?.querySelector('.product-related-videos__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };
        const updateArrows = () => {
          if (!this.track) return;
          if (this.previousArrow) this.previousArrow.disabled = this.track.scrollLeft <= 2;
          if (this.nextArrow) this.nextArrow.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        };
        this.previousArrow?.addEventListener('click', () => moveTrack(-1));
        this.nextArrow?.addEventListener('click', () => moveTrack(1));
        this.track?.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();

        this.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.open(trigger.dataset.videoTrigger));
        });

        this.querySelector('[data-video-close]')?.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.onClose());
      }

      open(panelId) {
        const activePanel = this.panels.find((panel) => panel.dataset.videoPanel === panelId);
        if (!activePanel) return;

        this.panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
        });

        if (this.dialogTitle && activePanel.dataset.videoTitle) {
          this.dialogTitle.textContent = activePanel.dataset.videoTitle;
        }

        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();

        const video = activePanel.querySelector('video');
        if (video && this.dataset.autoplay === 'true') {
          video.play().catch(() => {});
        }
      }

      onClose() {
        document.body.style.overflow = this.previousBodyOverflow;
        this.panels.forEach((panel) => {
          const video = panel.querySelector('video');
          if (!video) return;
          video.pause();
          if (this.dataset.restartOnClose === 'true') video.currentTime = 0;
          panel.hidden = true;
        });
      }
    }

    customElements.define('product-related-videos', ProductRelatedVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-review-video')) {
    class ProductReviewVideo extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        if (!this.track || !this.slides.length) return;

        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.interval = Number(this.dataset.interval) || 15000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.activeIndex = 0;
        this.scrollTimer = null;
        this.autoplayTimer = null;
        this.isPointerInside = false;

        this.onPrevious = () => this.goTo(this.activeIndex - 1, true);
        this.onNext = () => this.goTo(this.activeIndex + 1, true);
        this.onScroll = () => this.handleScroll();
        this.onKeydown = (event) => this.handleKeydown(event);
        this.onVisibilityChange = () => this.scheduleAutoplay();
        this.onPageShow = () => this.resetToFirstSlide();
        this.onResize = () => {
          this.updateNavigation();
          this.scheduleAutoplay();
        };
        this.onMouseEnter = () => {
          this.isPointerInside = true;
          this.scheduleAutoplay();
        };
        this.onMouseLeave = () => {
          this.isPointerInside = false;
          this.scheduleAutoplay();
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', () => this.scheduleAutoplay());
        this.addEventListener('focusout', () => this.scheduleAutoplay());
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        window.addEventListener('resize', this.onResize);
        window.addEventListener('pageshow', this.onPageShow);

        this.querySelectorAll('[data-review-play]').forEach((button) => {
          button.addEventListener('click', () => this.toggleVideo(button));
        });

        this.querySelectorAll('video').forEach((video) => {
          video.addEventListener('play', () => this.syncVideoState(video));
          video.addEventListener('pause', () => this.syncVideoState(video));
          video.addEventListener('ended', () => this.syncVideoState(video));
        });

        this.resetToFirstSlide();
      }

      disconnectedCallback() {
        window.clearTimeout(this.scrollTimer);
        window.clearTimeout(this.autoplayTimer);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      resetToFirstSlide() {
        this.activeIndex = 0;
        this.track.scrollLeft = 0;
        requestAnimationFrame(() => {
          this.track.scrollTo({ left: 0, behavior: 'auto' });
          this.updateNavigation();
          this.updateStatus();
          this.scheduleAutoplay();
        });
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.goTo(this.activeIndex + direction, true);
      }

      handleScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.activeIndex = closestIndex;
          this.updateStatus();
          this.scheduleAutoplay();
        }, 100);
      }

      goTo(index, userInitiated = false) {
        if (!this.slides.length) return;
        const targetIndex = (index + this.slides.length) % this.slides.length;
        const slide = this.slides[targetIndex];
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const targetLeft = this.track.scrollLeft + slideRect.left - trackRect.left;
        this.activeIndex = targetIndex;
        this.track.scrollTo({
          left: targetLeft,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
        this.updateStatus();
        if (userInitiated) this.scheduleAutoplay();
      }

      toggleVideo(button) {
        const slide = button.closest('[data-review-slide]');
        const video = slide?.querySelector('video');
        if (!video) return;

        this.slides.forEach((otherSlide) => {
          const otherVideo = otherSlide.querySelector('video');
          if (otherVideo && otherVideo !== video) {
            otherVideo.pause();
          }
        });

        if (video.paused) {
          video.controls = true;
          const playPromise = video.play();
          if (playPromise) {
            playPromise.catch(() => {
              video.controls = false;
              slide.classList.remove('is-playing');
            });
          }
        } else {
          video.pause();
        }

        this.scheduleAutoplay();
      }

      syncVideoState(video) {
        const slide = video.closest('[data-review-slide]');
        if (!slide) return;
        const isPlaying = !video.paused && !video.ended;
        slide.classList.toggle('is-playing', isPlaying);
        video.controls = isPlaying;
        this.scheduleAutoplay();
      }

      canScroll() {
        return this.track.scrollWidth > this.track.clientWidth + 2;
      }

      updateNavigation() {
        const canScroll = this.canScroll();
        if (this.previousButton) this.previousButton.hidden = !canScroll;
        if (this.nextButton) this.nextButton.hidden = !canScroll;
      }

      hasPlayingVideo() {
        return this.slides.some((slide) => {
          const video = slide.querySelector('video');
          return video && !video.paused && !video.ended;
        });
      }

      shouldPause() {
        return document.hidden || this.hasPlayingVideo() || (this.pauseOnHover && (this.isPointerInside || this.contains(document.activeElement)));
      }

      scheduleAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        if (!this.autoplay || this.slides.length < 2 || !this.canScroll() || this.shouldPause()) return;
        this.autoplayTimer = window.setTimeout(() => this.goTo(this.activeIndex + 1), this.interval);
      }

      updateStatus() {
        if (this.status) this.status.textContent = this.dataset.statusTemplate.replace('[index]', String(this.activeIndex + 1)).replace('[total]', String(this.slides.length));
      }
    }

    customElements.define('product-review-video', ProductReviewVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class ProductStickyAtc extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.button = this.querySelector('[data-sticky-button]');
      this.buttonLabel = this.querySelector('[data-sticky-button-label]');
      this.status = this.querySelector('[data-sticky-status]');
      this.image = this.querySelector('.product-sticky-atc__image');
      this.subtitle = this.querySelector('[data-sticky-subtitle]');
      this.busy = false;
      this.editorVisible = this.dataset.designMode === 'true';

      const { signal } = this.controller;
      this.button?.addEventListener('click', this.handleClick, { signal });
      document.addEventListener('shopify:product:select', this.handleProductSelect, { signal });
      document.addEventListener('shopify:cart:lines-update', this.handleCartUpdate, { signal });
      document.addEventListener('shopify:cart:error', this.handleCartError, { signal });
      document.addEventListener('shopify:section:select', this.handleSectionSelect, { signal });
      document.addEventListener('shopify:section:deselect', this.handleSectionDeselect, { signal });

      this.bindProductForm();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      window.clearTimeout(this.resetTimer);
      window.clearTimeout(this.fallbackTimer);
      if (this.targetButton) this.targetButton.dataset.puppet = 'false';
    }

    findProductForm() {
      const forms = Array.from(document.querySelectorAll('#MainContent .buy-buttons-block product-form-component'));
      const eligibleForms = forms.filter((form) => !form.closest('product-card, dialog'));
      return (
        eligibleForms.find((form) => form.dataset.productId === this.dataset.productId) ||
        eligibleForms[0] ||
        null
      );
    }

    bindProductForm() {
      this.observer?.disconnect();
      this.productForm = this.findProductForm();
      this.productInformationSection = this.productForm?.closest('.shopify-section') || null;
      this.targetButton = this.productForm?.querySelector('[ref="addToCartButton"]') || null;

      if (!this.productInformationSection) {
        this.pastProductInformation = false;
        this.updateVisibility();
        return;
      }

      this.syncButtonState();
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0 });
      this.observer.observe(this.productInformationSection);
    }

    handleIntersection = ([entry]) => {
      if (!entry) return;
      const rect = entry.target.getBoundingClientRect();
      this.pastProductInformation = !entry.isIntersecting && rect.bottom <= 0;
      this.updateVisibility();
    };

    updateVisibility() {
      const visible = Boolean(this.editorVisible || this.pastProductInformation);
      this.dataset.visible = String(visible);
      this.setAttribute('aria-hidden', String(!visible));
    }

    syncButtonState(variant) {
      if (!this.button) return;
      const available = variant ? variant.available !== false : !this.targetButton?.disabled;
      this.button.disabled = !available;

      if (!this.busy) {
        const label = available
          ? this.dataset.buttonLabel
          : variant === null
            ? this.dataset.unavailableLabel
            : this.dataset.soldOutLabel;
        this.setLabel(label);
      }
    }

    handleProductSelect = (event) => {
      if (!event.promise || typeof event.promise.then !== 'function') return;

      event.promise
        .then(({ detail }) => {
          if (!detail) return;
          if (detail.productId && String(detail.productId) !== String(this.dataset.productId)) return;

          const variant = detail.resource;
          if (detail.newProduct?.id) this.dataset.productId = String(detail.newProduct.id);

          window.requestAnimationFrame(() => {
            this.bindProductForm();
            this.updateVariant(variant);
          });
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') this.resetButton(false);
        });
    };

    updateVariant(variant) {
      this.syncButtonState(variant);

      if (this.subtitle && !this.subtitle.textContent.trim() && variant?.title && variant.title !== 'Default Title') {
        this.subtitle.textContent = variant.title;
      } else if (this.subtitle?.dataset.variantTitle === 'true' && variant?.title) {
        this.subtitle.textContent = variant.title === 'Default Title' ? '' : variant.title;
      }

      if (this.dataset.useProductImage !== 'true' || !this.image) return;
      const source = variant?.featured_media?.preview_image?.src;
      if (!source) return;

      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '240');
      this.image.src = url.toString();
      this.image.removeAttribute('srcset');
    }

    handleClick = () => {
      this.targetButton = this.productForm?.querySelector('[ref="addToCartButton"]') || this.targetButton;
      if (!this.targetButton || this.targetButton.disabled || this.busy) return;

      this.busy = true;
      this.button?.setAttribute('aria-busy', 'true');
      this.setLabel(this.dataset.addingLabel);
      this.targetButton.dataset.puppet = 'true';
      this.targetButton.click();

      window.clearTimeout(this.fallbackTimer);
      this.fallbackTimer = window.setTimeout(() => this.resetButton(false), 8000);
    };

    handleCartUpdate = (event) => {
      if (!this.busy) return;
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(() => this.resetButton(true)).catch(() => this.resetButton(false));
      } else {
        this.resetButton(true);
      }
    };

    handleCartError = () => {
      if (this.busy) this.resetButton(false);
    };

    resetButton(success) {
      window.clearTimeout(this.fallbackTimer);
      if (this.targetButton) this.targetButton.dataset.puppet = 'false';
      this.button?.removeAttribute('aria-busy');
      this.busy = false;

      if (success) {
        this.setLabel(this.dataset.addedLabel);
        if (this.status) this.status.textContent = this.dataset.addedLabel || '';
        window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(() => {
          this.syncButtonState();
          if (this.status) this.status.textContent = '';
        }, 1000);
      } else {
        this.syncButtonState();
      }
    }

    setLabel(label) {
      if (this.buttonLabel && label) this.buttonLabel.textContent = label;
    }

    handleSectionSelect = (event) => {
      if (String(event.detail?.sectionId) !== String(this.dataset.sectionId)) return;
      this.editorVisible = true;
      this.updateVisibility();
    };

    handleSectionDeselect = (event) => {
      if (String(event.detail?.sectionId) !== String(this.dataset.sectionId)) return;
      this.editorVisible = false;
      this.updateVisibility();
    };
  }

  if (!customElements.get('product-sticky-atc')) {
    customElements.define('product-sticky-atc', ProductStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipes-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recipes-overview')) {
    customElements.define(
      'recipes-overview',
      class RecipesOverview extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-recipe-grid]');
          this.dialog = this.querySelector('[data-filter-dialog]');
          this.form = this.querySelector('[data-filter-form]');
          this.pagination = this.querySelector('[data-pagination]');
          this.emptyState = this.querySelector('[data-filter-empty]');
          this.status = this.querySelector('[data-results-status]');
          this.sort = this.querySelector('[data-recipe-sort]');
          this.dietTabs = this.querySelector('[data-diet-tabs]');
          this.dietOptions = this.querySelector('[data-diet-options]');
          this.pageSize = Number(this.dataset.pageSize) || 9;
          this.currentPage = 1;
          this.appliedFilters = { diet: [], meal: [], prep: [] };

          this.bindEvents();

          if (!this.grid) return;

          this.refreshCards();
          this.syncDietFilters();
          this.applyResults();
          this.loadRemainingArticles();
        }

        bindEvents() {
          this.dietTabs?.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-diet-tab]');
            if (tab) this.selectDietTab(tab);
          });

          this.querySelector('[data-open-filters]')?.addEventListener('click', () => {
            this.syncFormToApplied();
            this.dialog?.showModal();
          });

          this.querySelector('[data-close-filters]')?.addEventListener('click', () => this.dialog?.close());
          this.querySelector('[data-apply-filters]')?.addEventListener('click', () => {
            this.readAppliedFilters();
            this.currentPage = 1;
            this.applyResults();
            this.dialog?.close();
          });

          this.querySelector('[data-clear-filters]')?.addEventListener('click', () => {
            this.form?.querySelectorAll('input[type="checkbox"]').forEach((input) => {
              input.checked = false;
            });
            this.readAppliedFilters();
            this.currentPage = 1;
            this.applyResults();
          });

          this.dialog?.addEventListener('click', (event) => {
            if (event.target !== this.dialog) return;
            const bounds = this.dialog.getBoundingClientRect();
            const inside =
              event.clientX >= bounds.left &&
              event.clientX <= bounds.right &&
              event.clientY >= bounds.top &&
              event.clientY <= bounds.bottom;
            if (!inside) this.dialog.close();
          });

          this.sort?.addEventListener('change', () => {
            this.currentPage = 1;
            this.applyResults();
          });
        }

        refreshCards() {
          this.cards = Array.from(this.querySelectorAll('[data-recipe-card]'));
          this.cards.forEach((card, index) => {
            card.dataset.originalIndex = index;
          });
        }

        normalize(value) {
          const slug = String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLocaleLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          const aliases = {
            'gluten-free': 'glutenvrij',
            'lactose-free': 'lactosevrij',
            'sugar-free': 'suikervrij',
            'sugar-low': 'suikerarm',
            'low-sugar': 'suikerarm',
            'high-in-protein': 'eiwitrijk',
            'high-protein': 'eiwitrijk',
            'low-in-protein': 'eiwitarm',
            'low-protein': 'eiwitarm',
            'custom-texture': 'aangepaste-textuur',
            'low-fodmap': 'fodmap-arm'
          };
          return aliases[slug] || slug;
        }

        dietParts(rawValue) {
          let values;
          try {
            const parsed = JSON.parse(rawValue || '[]');
            values = Array.isArray(parsed) ? parsed : [parsed];
          } catch {
            values = String(rawValue || '').split(/[|,;]+/);
          }

          return values
            .map((value) => String(value || '').trim())
            .filter(Boolean);
        }

        dietAliases(value) {
          return [...new Set(
            [value, ...String(value || '').split(/[\/,;|]+/)]
              .map((part) => this.normalize(part))
              .filter(Boolean)
          )];
        }

        syncDietFilters() {
          if (!this.dietTabs || !this.dietOptions) return;

          this.querySelectorAll('[data-dynamic-diet]').forEach((element) => element.remove());

          const usedDiets = new Map();
          this.cards.forEach((card) => {
            this.dietParts(card.dataset.primaryDiets).forEach((label) => {
              const key = this.normalize(label);
              if (key && !usedDiets.has(key)) usedDiets.set(key, label);
            });
          });

          const availableAliases = new Set();
          usedDiets.forEach((label) => {
            this.dietAliases(label).forEach((alias) => availableAliases.add(alias));
          });

          const existingTabs = Array.from(this.querySelectorAll('[data-diet-tab]:not([data-dynamic-diet])'));
          existingTabs.forEach((tab) => {
            if (!tab.dataset.value) return;
            tab.hidden = !availableAliases.has(this.normalize(tab.dataset.value));
          });

          this.form?.querySelectorAll('input[name="diet"]').forEach((input) => {
            const option = input.closest('label');
            if (option) option.hidden = !availableAliases.has(this.normalize(input.value));
          });

          usedDiets.forEach((label) => {
            const aliases = this.dietAliases(label);
            const alreadyRepresented = existingTabs.some(
              (tab) => tab.dataset.value && aliases.includes(this.normalize(tab.dataset.value))
            );
            if (alreadyRepresented) return;

            const tab = document.createElement('button');
            tab.className = 'recipes-overview__diet-tab';
            tab.type = 'button';
            tab.dataset.dietTab = '';
            tab.dataset.dynamicDiet = '';
            tab.dataset.value = label;
            tab.setAttribute('aria-pressed', 'false');
            tab.textContent = label;
            this.dietTabs.append(tab);

            const option = document.createElement('label');
            option.className = 'recipes-overview__checkbox-option';
            option.dataset.dynamicDiet = '';

            const input = document.createElement('input');
            input.type = 'checkbox';
            input.name = 'diet';
            input.value = label;

            const checkbox = document.createElement('span');
            checkbox.className = 'recipes-overview__checkbox';
            checkbox.setAttribute('aria-hidden', 'true');
            checkbox.innerHTML = '<svg viewBox="0 0 14 14"><path d="m3 7 2.5 2.5L11 4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"/></svg>';

            const text = document.createElement('span');
            text.textContent = label;
            option.append(input, checkbox, text);
            this.dietOptions.append(option);
          });
        }

        selectDietTab(selectedTab) {
          this.querySelectorAll('[data-diet-tab]').forEach((tab) => {
            const isActive = tab === selectedTab;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', String(isActive));
          });

          const value = selectedTab.dataset.value || '';
          if (!this.form) return;
          this.form.querySelectorAll('input[name="diet"]').forEach((input) => {
            input.checked = value !== '' && this.normalize(input.value) === this.normalize(value);
          });
          this.readAppliedFilters();
          this.currentPage = 1;
          this.applyResults();
        }

        readAppliedFilters() {
          if (!this.form) return;
          ['diet', 'meal', 'prep'].forEach((group) => {
            this.appliedFilters[group] = Array.from(
              this.form.querySelectorAll(`input[name="${group}"]:checked`)
            ).map((input) => this.normalize(input.value));
          });
        }

        syncFormToApplied() {
          if (!this.form) return;
          ['diet', 'meal', 'prep'].forEach((group) => {
            this.form.querySelectorAll(`input[name="${group}"]`).forEach((input) => {
              input.checked = this.appliedFilters[group].includes(this.normalize(input.value));
            });
          });
        }

        cardMatches(card) {
          return ['diet', 'meal', 'prep'].every((group) => {
            const selections = this.appliedFilters[group];
            if (selections.length === 0) return true;
            const values = group === 'diet' ? this.cardDiets(card) : [this.normalize(card.dataset[group])];
            return selections.some((selection) => values.includes(selection));
          });
        }

        cardDiets(card) {
          return [...new Set(
            this.dietParts(card.dataset.diets)
              .flatMap((value) => this.dietAliases(value))
          )];
        }

        sortCards(cards) {
          const sortMode = this.sort?.value || 'newest';
          return cards.sort((a, b) => {
            if (sortMode === 'title') {
              return String(a.dataset.title || '').localeCompare(String(b.dataset.title || ''), undefined, {
                sensitivity: 'base'
              });
            }

            const aDate = Number(a.dataset.published) || 0;
            const bDate = Number(b.dataset.published) || 0;
            if (aDate === bDate) {
              return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
            }
            return sortMode === 'oldest' ? aDate - bDate : bDate - aDate;
          });
        }

        applyResults(scrollToGrid = false) {
          if (!this.grid || !this.cards) return;

          const matching = this.sortCards(this.cards.filter((card) => this.cardMatches(card)));
          const showFallback = matching.length === 0 && this.cards.length > 0;
          const displayed = showFallback ? this.sortCards([...this.cards]) : matching;
          const displayedSet = new Set(displayed);
          displayed.forEach((card) => this.grid.append(card));
          this.cards.filter((card) => !displayedSet.has(card)).forEach((card) => this.grid.append(card));

          const totalPages = Math.max(1, Math.ceil(displayed.length / this.pageSize));
          this.currentPage = Math.min(this.currentPage, totalPages);
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;

          this.cards.forEach((card) => {
            card.hidden = true;
            card.removeAttribute('data-page-position');
            card.dataset.cardLayout = 'featured';
          });

          displayed.slice(start, end).forEach((card, index) => {
            const position = index + 1;
            card.hidden = false;
            card.dataset.pagePosition = position;
            card.dataset.cardLayout = 'featured';
          });

          if (this.emptyState) this.emptyState.hidden = matching.length !== 0;
          if (this.status) {
            const noun = matching.length === 1 ? this.dataset.recipeSingular : this.dataset.recipePlural;
            this.status.textContent = `${matching.length} ${noun}`;
          }

          this.updateDietTabs();
          this.updateFilterCount();
          this.renderPagination(displayed.length);

          if (scrollToGrid) {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.grid.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          }
        }

        updateDietTabs() {
          const selectedDiets = this.appliedFilters.diet;
          this.querySelectorAll('[data-diet-tab]').forEach((tab) => {
            const value = this.normalize(tab.dataset.value);
            const isActive =
              (value === '' && selectedDiets.length === 0) ||
              (selectedDiets.length === 1 && selectedDiets[0] === value);
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', String(isActive));
          });
        }

        updateFilterCount() {
          const count = Object.values(this.appliedFilters).reduce((total, values) => total + values.length, 0);
          const badge = this.querySelector('[data-filter-count]');
          if (!badge) return;
          badge.hidden = count === 0;
          badge.textContent = String(count);
        }

        pageItems(totalPages) {
          if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
          const values = new Set([1, totalPages, this.currentPage - 1, this.currentPage, this.currentPage + 1]);
          const pages = Array.from(values)
            .filter((page) => page >= 1 && page <= totalPages)
            .sort((a, b) => a - b);
          const items = [];
          pages.forEach((page, index) => {
            if (index > 0 && page - pages[index - 1] > 1) items.push('gap');
            items.push(page);
          });
          return items;
        }

        renderPagination(resultCount) {
          if (!this.pagination) return;
          const totalPages = Math.ceil(resultCount / this.pageSize);
          this.pagination.replaceChildren();
          this.pagination.hidden = totalPages <= 1;
          if (totalPages <= 1) return;

          this.pagination.append(
            this.paginationButton('previous', this.currentPage - 1, this.currentPage === 1)
          );

          this.pageItems(totalPages).forEach((item) => {
            if (item === 'gap') {
              const gap = document.createElement('span');
              gap.className = 'recipes-overview__pagination-gap';
              gap.textContent = '…';
              gap.setAttribute('aria-hidden', 'true');
              this.pagination.append(gap);
              return;
            }
            this.pagination.append(this.paginationButton(String(item), item, false, item === this.currentPage));
          });

          this.pagination.append(
            this.paginationButton('next', this.currentPage + 1, this.currentPage === totalPages)
          );
        }

        paginationButton(label, page, disabled, current = false) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'recipes-overview__pagination-button';
          button.disabled = disabled;

          if (label === 'previous' || label === 'next') {
            button.classList.add('is-arrow');
            button.setAttribute(
              'aria-label',
              label === 'previous' ? this.dataset.previousLabel : this.dataset.nextLabel
            );
            button.innerHTML =
              label === 'previous'
                ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12 5-5 5 5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>'
                : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m8 5 5 5-5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>';
          } else {
            button.textContent = label;
            button.setAttribute('aria-label', `Page ${label}`);
          }

          if (current) {
            button.classList.add('is-current');
            button.setAttribute('aria-current', 'page');
          }

          button.addEventListener('click', () => {
            this.currentPage = page;
            this.applyResults(true);
          });
          return button;
        }

        async loadRemainingArticles() {
          const source = this.querySelector('[data-source-pages]');
          const totalPages = Number(source?.dataset.sourcePages) || 1;
          if (totalPages <= 1) return;

          const pageParam = source.dataset.pageParam || 'page';
          const batches = [];
          for (let page = 2; page <= totalPages; page += 4) {
            const pageNumbers = [];
            for (let offset = 0; offset < 4 && page + offset <= totalPages; offset += 1) {
              pageNumbers.push(page + offset);
            }
            batches.push(pageNumbers);
          }

          const knownIds = new Set(this.cards.map((card) => card.dataset.recipeId));

          for (const batch of batches) {
            const responses = await Promise.all(
              batch.map(async (page) => {
                try {
                  const url = new URL(window.location.href);
                  url.searchParams.set('section_id', this.dataset.sectionId);
                  url.searchParams.set(pageParam, String(page));
                  const response = await fetch(url.toString(), {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                  });
                  if (!response.ok) return [];
                  const markup = await response.text();
                  const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
                  return Array.from(documentFragment.querySelectorAll('[data-recipe-card]'));
                } catch {
                  return [];
                }
              })
            );

            responses.flat().forEach((card) => {
              if (knownIds.has(card.dataset.recipeId)) return;
              knownIds.add(card.dataset.recipeId);
              this.grid.append(document.importNode(card, true));
            });
          }

          this.refreshCards();
          this.syncDietFilters();
          this.applyResults();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
